<template>
  <FlashSalesSticker
    v-if="deal"
    :button-label="deal.buttonLabel"
    class="my-8 w-full sm:mb-16 sm:mt-0 md:w-auto"
    :icon="deal.icon"
    :is-layered="deal.isLayered"
    @click="deal.onClick()"
  >
    <template #title>
      {{ deal.title }}
    </template>
    <template #description>
      {{ deal.description }}
      <IconInfo v-if="deal.showInfoIcon" class="ml-4 h-16 w-16 shrink-0" />
    </template>
  </FlashSalesSticker>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import FlashSalesSticker from '@backmarket/nuxt-layer-recommendation/FlashSalesSticker.vue'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconPriceTagFilled } from '@ds/icons/IconPriceTagFilled'

import { MODAL_NAMES } from './FlashSalesSticker.constants'
import translations from './FlashSalesSticker.translations'

const i18n = useI18n()
const experiments = useExperiments()

const { discount, hasDeals } = defineProps<{
  hasDeals: boolean
  discount?: Price
}>()

const isFlashSalesEnabled = experiments['experiment.flashSales'] === 'enabled'
const isSellerFlashSalesEnabled =
  experiments['experiment.sellerFlashSales'] === 'with'

const deal = computed(() => {
  if (isFlashSalesEnabled && discount)
    return {
      title: i18n(translations.flashSalesTitle, {
        price: i18n.price(discount),
      }),
      description: i18n(translations.flashSalesDescription),
      icon: IconBoltFilled,
      showInfoIcon: true,
      onClick: () => openModal(MODAL_NAMES.FLASH_SALES),
    }
  if (isSellerFlashSalesEnabled && hasDeals) {
    return {
      title: i18n(translations.sellerFlashSalesTitle),
      description: i18n(translations.sellerFlashSalesDescription),
      icon: IconPriceTagFilled,
      buttonLabel: i18n(translations.sellerFlashSalesButtonLabel),
      isLayered: true,
      onClick: () => openModal(MODAL_NAMES.SELLER_FLASH_SALES),
    }
  }

  return null
})
</script>
